import * as Popover from "@radix-ui/react-popover";
import { useTranslation } from "react-i18next";

import { HorizontalDots } from "../../../../../../assets/icons/HorizontalDots";
import { Toggle } from "../../../../../../components/Toggle";
import {
  ExportItem,
  OptionItem,
  OptionsContainer,
  StyledPopoverContent,
  StyledPopoverTrigger,
} from "./OptionsPopover.styles";

// EN-4852: overflow ("...") menu for the spirometry session graph. Since this
// menu only renders while a session's details are open, it also hosts the
// "Pin graph to patient page" toggle (previously a standalone menu). The
// remaining design controls (Interpolation, Scale y-axis, Data display, FVC
// quality hide) are out of scope and tracked separately.

type OptionsPopoverProps = {
  onExport?: () => void;
  isExporting?: boolean;
  disabled?: boolean;
  isPinned?: boolean;
  // When provided, the "Pin graph to patient page" toggle is shown.
  onPinnedChange?: (isPinned: boolean) => void;
  // The export action is only available while a session's details are open.
  showExport?: boolean;
};

export function OptionsPopover({
  onExport,
  isExporting = false,
  disabled = false,
  isPinned = false,
  onPinnedChange,
  showExport = true,
}: OptionsPopoverProps) {
  const { t } = useTranslation();

  return (
    <Popover.Root>
      <StyledPopoverTrigger
        disabled={disabled}
        aria-label={t("patientPage_measurementModal_sessionOptions")}
      >
        <HorizontalDots />
      </StyledPopoverTrigger>

      <Popover.Portal>
        <StyledPopoverContent align="end" sideOffset={8}>
          <OptionsContainer>
            {onPinnedChange && (
              <OptionItem>
                <p>{t("patientPage_measurementModal_pinGraph")}</p>
                <Toggle checked={isPinned} onCheckedChange={onPinnedChange} />
              </OptionItem>
            )}
            {showExport && (
              <ExportItem
                type="button"
                disabled={isExporting}
                onClick={onExport}
              >
                {t("patientPage_measurementModal_exportSessionPdf")}
              </ExportItem>
            )}
          </OptionsContainer>
        </StyledPopoverContent>
      </Popover.Portal>
    </Popover.Root>
  );
}
